module.exports = __webpack_public_path__ + "assets/img/28.9b736791.png";